import React from 'react';
import styled from "styled-components";
import {ReactComponent as Icon} from '../assets/icons/iconmonstr-magnifier-lined.svg';


const IconoSearch = styled(Icon)`
margin-left: 10px;
height: 20px;
fill: #fff;
`


const IconSearch = () => {
    return ( 
        <>
            <IconoSearch></IconoSearch>
        </>
     );
}
 
export default IconSearch;